module.exports = __webpack_public_path__ + "static/media/Create-Template.aae04dda.jpg";